var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[(_vm.hasEvent)?_c('i',{staticClass:"fa fa-exclamation-triangle",style:(("color:" + _vm.eventColor))}):_vm._e(),_vm._v("\n     \n    "+_vm._s(_vm.convertPerfData())+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68fb0ed9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/textLabel/RscPerfEventTextLabel.vue
// module id = null
// module chunks = 